<div class="external-page">
    <div id="digital-card-content" class="on-top digital-card">
        <header class="card-header">
            <img class="header-logo-image" src="/public/assets/images/welion-header-logo.png" />
        </header>
        <section class="cutout-section">
            <div class="cutout-container">
                <img class="cutout-image" src="/public/assets/images/digital-card-cutout.png" />
                <div class="cutout-text">
                    <div class="text-font full-name">{{digitalCard.name}} {{digitalCard.surname}}</div>
                    <div class="text-font tax-code">{{digitalCard.taxId}}</div>
                    <div class="text-font expire-text">
                        Scade il <span>{{digitalCard.expirationDate}}</span>
                    </div>
                </div>
            </div>
            <div class="arrow-up">
                <img src="/public/assets/images/arrow-up.png" />
            </div>
            <div class="card-text">
                {{'digitalCard.title' | translate}}
            </div>
            <div class="description-text">
                {{'digitalCard.description' | translate}} <br/>
                {{'digitalCard.description-two' | translate}}            
            </div>
        </section>
        <footer>
            <div class="footer-img-container">
                <img class="welion-logo-footer" src="/public/assets/images/welion-long-logo.png" />
                <img class="small-logo" src="/public/assets/images/welion-small-logo.png" />
            </div>
        </footer>
    </div>
</div>